import { ElementNode, type LexicalNode } from "lexical";

export class WidgetNode extends ElementNode {
  __widget: string;
  __margin = "0px";
  __padding = "5px 10px";
  __fontWeight = "bold";
  __fontFamily = "inherit";
  __background = "rgba(230, 244, 255, 1)";
  __color = "rgba(22, 119, 255, 1)";
  __display = "inline";

  static getType(): string {
    return "widget";
  }

  // eslint-disable-next-line no-use-before-define
  static clone(node: WidgetNode): WidgetNode {
    return new WidgetNode(node.__widget, node.__key);
  }

  constructor(widget: string, key?: KeyType) {
    super(key);
    this.__widget = widget;
  }

  setWidget(widget: string) {
    const self = this.getWritable();
    self.__widget = widget;
  }

  getWidget() {
    const self = this.getLatest();
    return self.__widget;
  }

  exportDOM(editor: LexicalEditor): DOMExportOutput {
    const element = document.createElement("span");
    element.textContent = this.__widget;
    element.style.margin = this.__margin;
    element.style.padding = this.__padding;
    element.style.fontFamily = this.__fontFamily;
    element.style.fontWeight = this.__fontWeight;
    element.style.fontSize = this.__fontSize;
    element.style.background = this.__background;
    element.style.color = this.__color;
    element.style.display = this.__display;
    element.dataset.name = this.__widget;
    return { element };
  }

  static importDOM(): DOMConversionMap | null {
    return {
      span: (domNode: HTMLElement) => {
        if (domNode.getAttribute("data-name") !== "RECEPIENT_NAME") {
          return null;
        }

        return {
          conversion: (domNode: HTMLElement) => {
            return {
              node: $createWidgetNode(domNode.getAttribute("data-name")),
            };
          },
          priority: 1,
        };
      },
    };
  }

  createDOM(): HTMLElement {
    const dom = document.createElement("span");
    dom.innerText = this.__widget;
    dom.style.margin = this.__margin;
    dom.style.padding = this.__padding;
    dom.style.fontFamily = this.__fontFamily;
    dom.style.fontWeight = this.__fontWeight;
    dom.style.fontSize = this.__fontSize;
    dom.style.background = this.__background;
    dom.style.color = this.__color;
    dom.style.display = this.__display;
    dom.dataset.name = this.__widget;

    return dom;
  }

  updateDOM(prevNode: WidgetNode, dom: HTMLElement): boolean {
    return false;
  }
}

export function $createWidgetNode(widgetName: string): WidgetNode {
  return new WidgetNode(widgetName);
}

export function $isWidgetNode(
  node: LexicalNode | null | undefined
): WidgetNode {
  return node instanceof WidgetNode;
}
